import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import * as API from 'services';

import {
	formatWorkerProgramStatusExcelList,
	formatWorkerProgramStatusList,
} from './worker-program-status.helper';
import { WorkerProgramStatusActions } from './worker-program-status.redux';
import {
	IPayloadDeleteWorkerProgramStatusRequest,
	IPayloadGetWorkerProgramStatusExcelListRequest,
	IPayloadGetWorkerProgramStatusListRequest,
} from './worker-program-status.type';

export function* getWorkerProgramStatusList(
	action: PayloadAction<IPayloadGetWorkerProgramStatusListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerProgramStatusListResponse> =
			yield API.getWorkerProgramStatusList({ searchTypes, ...rest });
		const content = formatWorkerProgramStatusList(res?.data?.content);

		yield put(
			WorkerProgramStatusActions.getWorkerProgramStatusListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerProgramStatusActions.getWorkerProgramStatusListFailure());
	}
}

export function* getWorkerProgramStatusExcelList(
	action: PayloadAction<IPayloadGetWorkerProgramStatusExcelListRequest>
) {
	const { callback, searchTypes, ...rest } = action.payload;

	try {
		const res: API.ApiResponseSuccess<API.GetWorkerProgramStatusListResponse> =
			yield API.getWorkerProgramStatusList({ searchTypes, ...rest });
		const content = formatWorkerProgramStatusExcelList(res?.data?.content);

		yield put(
			WorkerProgramStatusActions.getWorkerProgramStatusExcelListSuccess()
		);
		callback?.({ data: content });
	} catch (error) {
		callback?.({ error });
		yield put(
			WorkerProgramStatusActions.getWorkerProgramStatusExcelListFailure()
		);
	}
}

export function* deleteWorkerProgramStatus(
	action: PayloadAction<IPayloadDeleteWorkerProgramStatusRequest>
) {
	const { callback, ids } = action.payload;

	try {
		yield API.deleteWorkerProgram(ids);

		yield put(WorkerProgramStatusActions.deleteWorkerProgramStatusSuccess());
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerProgramStatusActions.deleteWorkerProgramStatusFailure());
	}
}
